/** @jsxImportSource @emotion/react */

import { useState } from "react";
import UI from "@mile-meeting/mile-ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const BackBtnContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 20px 0 0 40px;
`;

const BackBtn = ({ onClick }: { onClick?: () => void }) => {
  return (
    <BackBtnContainer>
      <UI.IconButton.Outline
        size={24}
        icon="arrowLeft"
        onClick={onClick}
        color="var(--alias-color-label-alternative)"
      />
      <UI.Typography type="headline01" fontStyle="medium" color="var(--alias-color-label-alternative)">
        뒤로 돌아가기
      </UI.Typography>
    </BackBtnContainer>
  );
};

export default BackBtn;
